module.exports = __webpack_public_path__ + "static/columnDefinitions-d9cc8c084250cd7a37d6401b1bdd3b1a.gif";